<template>
  <div v-title data-title="身份认证">
    <wv-group>
      <wvi-input
        label="姓名"
        placeholder="请填写姓名，与身份证保持一致"
        ref="1"
        v-model="formset.Name"
        :validate-info="{errormsg:'姓名不可为空'}"
        required
      ></wvi-input>
      <wvi-input
        label="用户名"
        placeholder="用户名"
        :value="formset.UserName"
        :disabled="true"
        v-if="false"
      ></wvi-input>
      <!-- <wvi-input label="公司" :value="formset.SysCompanyName" v-if="formset.SysCompanyName" :disabled="true"></wvi-input> -->
      <wvi-input
        v-if="false"
        label="QQ"
        placeholder="QQ"
        v-model="formset.QQ"
        ref="2"
        pattern="^[1-9][0-9]{4,9}$"
        :validate-info="{errormsg:'QQ不合法'}"
      ></wvi-input>
      <wvi-input
        label="绑定手机号"
        placeholder="绑定手机号"
        v-model="formset.Telephone"
        ref="3"
        pattern="^[1][3,4,5,7,8,9][0-9]{9}$"
        maxlength="11"
        :validate-info="{errormsg:'联系电话不合法'}"
        required
      ></wvi-input>
      <div v-if="oldPhone!=formset.Telephone" class="weui-cell weui-cell_vcode">
        <div class="weui-cell__bd">
          <input class="yzm" type="text" placeholder="图形验证码" v-model="PicCodeValue" />
        </div>
        <img
          @click="getpiccode()"
          v-bind:src="'data:image/png;base64,'+VerificationCodePic.Base64"
          style="width:25%;margin-right:3%"
        />
      </div>
      <div v-if="oldPhone!=formset.Telephone" class="weui-cell weui-cell_vcode">
        <div class="weui-cell__bd">
          <input class="yzm" type="tel" placeholder="请输入短信码" maxlength="6" v-model="code" />
          <div class="btn-vercode">
            <button
              class="weui-btn weui-btn_mini btn-orange"
              style="width:inherit"
              v-if="getcodeshow&&formset.Telephone.length==11&&PicCodeValue.length>0"
              @click="getcode()"
            >获取验证码</button>
            <button
              class="weui-btn weui-btn_mini btn-orange"
              style="width:inherit"
              v-if="getcodeshow&&(formset.Telephone.length!=11||PicCodeValue.length==0)"
            >获取验证码</button>
            <button
              class="weui-btn weui-btn_mini btn-orange"
              style="width:inherit;background-color:#ccc"
              v-if="!getcodeshow"
            >{{waitminutes}}秒</button>
          </div>
        </div>
      </div>
      <!-- <wvi-input
        v-if="loginType==4"
        label="身份证号码"
        placeholder="身份证号码"
        :value="formset.IdentityCard"
        :disabled="true"
      ></wvi-input>-->
      <div v-if="loginType==4" class="weui-cell">
        <div class="weui-cell__bd">
          <div class="weui-uploader">
            <div class="weui-uploader__hd">
              <p class="weui-uploader__title">
                身份证正面
                <span
                  v-if="formset.IdCardIsCheck!=2"
                  style="color:red;font-size:1.2rem"
                >（请上传4MB以内的图片）</span>
              </p>
            </div>
            <div class="weui-uploader__bd">
              <div v-if="formset.IdCardIsCheck!=2" class="weui-uploader__input-box">
                <input
                  name="file"
                  @change="uploadInpuFrontChange($event)"
                  id="uploaderInput"
                  class="weui-uploader__input"
                  type="file"
                  accept="image/*"
                />
              </div>
              <img :src="idCardsrc.idCardfront" height="75px" />
            </div>
          </div>
        </div>
      </div>
      <div v-if="loginType==4" class="weui-cell">
        <div class="weui-cell__bd">
          <div class="weui-uploader">
            <div class="weui-uploader__hd">
              <p class="weui-uploader__title">
                身份证背面
                <span
                  v-if="formset.IdCardIsCheck!=2"
                  style="color:red;font-size:1.2rem"
                >（请上传4MB以内的图片）</span>
              </p>
            </div>
            <div class="weui-uploader__bd">
              <div v-if="formset.IdCardIsCheck!=2" class="weui-uploader__input-box">
                <input
                  name="file"
                  @change="uploadInpuBackChange($event)"
                  id="uploaderInput"
                  class="weui-uploader__input"
                  type="file"
                  accept="image/*"
                />
              </div>
              <img :src="idCardsrc.idCardback" height="75px" />
            </div>
          </div>
        </div>
      </div>
      <div class="weui-cell"  v-if="formset.IdCardIsCheck>0">
        <div class="weui-cell__hd">
          <label class="weui-label" style="width: 105px;">
            审核状态
          </label>
        </div>
        <div class="weui-cell__bd">
          <input type="text" auto-complete="off" v-if="formset.IdCardIsCheck==1" value="待审核" class="weui-input">
          <input type="text" auto-complete="off" v-if="formset.IdCardIsCheck==2" value="已认证" class="weui-input">
          <input type="text" auto-complete="off" v-if="formset.IdCardIsCheck==3" value="认证失败" class="weui-input">
        </div>
        <div class="weui-cell__ft">
        </div>
      </div>
      <div class="weui-cell"  v-if="formset.IdCardIsCheck==3">
        <div class="weui-cell__hd">
          <label class="weui-label" style="width: 105px;">
            失败原因
          </label>
        </div>
        <div class="weui-cell__bd">
          {{formset.Reason}}
        </div>
        <div class="weui-cell__ft">
        </div>
      </div>
      <div class="weui-cell">
        <wv-button type="primary" v-if="formset.IdCardIsCheck==2">已认证</wv-button>
        <wv-button type="primary" v-else @click="btnSave()">提交认证</wv-button>
      </div>
    </wv-group>
  </div>
</template>
<script>
import { Toast } from "we-vue";
export default {
  name: "messageset",
  data() {
    return {
      formset: {},
      idCardsrc: { idCardfront: "", idCardback: "" },
      loginType: -1,
      VerificationCodePic: { OnceString: "" }, //图形验证码信息
      PicCodeValue: "", //图形验证码值
      getcodeshow: true,
      waitminutes: "",
      codetimer: null,
      code: "",
      oldPhone: ""
    };
  },
  created: function() {
    this.InitMessage();
    this.getpiccode();
  },
  methods: {
    validatesave: function() {
      var com = this.$refs;
      var flag = true;
      for (var c in com) {
        if (this.$refs[c].length != undefined) {
          this.$refs[c][0].validate();
          flag = this.$refs[c][0].valid;
        } else {
          this.$refs[c].validate();
          flag = this.$refs[c].valid;
        }

        if (!flag) return flag;
      }
      return flag;
    },
    InitMessage: function() {
      this.$http.get(this.GLOBAL.BASE_URL + "api/login/get", {}).then(
        function(d) {
          var rep = JSON.parse(d.bodyText);
          if (rep.Success) {
            this.formset = rep.Data;
            this.loginType = rep.Data.Type;
            this.oldPhone = rep.Data.Telephone;
            if(this.formset.IdCardIsCheck!=2){
            this.formset.Name="";
            }
            if (
              rep.Data.IdCardFontUrl != undefined &&
              rep.Data.IdCardFontUrl != null &&
              rep.Data.IdCardFontUrl != ""
            ) {
              this.idCardsrc.idCardfront =
                this.GLOBAL.BASE_URL + rep.Data.IdCardFontUrl;
            }
            if (
              rep.Data.IdCardBackUrl != undefined &&
              rep.Data.IdCardBackUrl != null &&
              rep.Data.IdCardBackUrl != ""
            ) {
              this.idCardsrc.idCardback =
                this.GLOBAL.BASE_URL + rep.Data.IdCardBackUrl;
            }
          } else {
            Toast.fail(rep.Message);
          }
        },
        function(d) {
          console.log(d);
        }
      );
    },
    btnSave: function() {
      if (this.loginType == 4) {
        if (
          this.idCardsrc.idCardfront == undefined ||
          this.idCardsrc.idCardfront == null ||
          this.idCardsrc.idCardfront == ""
        ) {
          Toast.fail("身份证正面不可为空");
          return;
        }
        if (
          this.idCardsrc.idCardback == undefined ||
          this.idCardsrc.idCardback == null ||
          this.idCardsrc.idCardback == ""
        ) {
          Toast.fail("身份证背面不可为空");
          return;
        }
      }
      if (!this.validatesave()) {
        Toast.fail("验证没通过");
        return;
      } else if (this.oldPhone != this.formset.Telephone) {
        this.checkcode();
      } else {
        this.dosave();
      }
    },
    dosave: function() {
      this.$store.commit("showLoading");
      this.$http
        .post(this.GLOBAL.BASE_URL + "api/login/update", this.formset, {
          emulateJSON: true
        })
        .then(
          function(d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
              Toast.success("提交成功");
              this.$router.push("/app/my");
            } else {
              Toast.fail(rep.Message);
            }
            this.$store.commit("hideLoading");
          },
          function(d) {
            console.log(d);
          }
        );
    },
    uploadInpuFrontChange: function(e) {
      let src,
        url = window.URL || window.webkitURL || window.mozURL,
        files = e.target.files,
        self = this;
      for (var i = 0, len = files.length; i < len; ++i) {
        var file = files[i];
        // alert("图片大小" + file.size);
        if (file.size > 4 * 1024 * 1024) {
          Toast.fail("身份证图片大小4MB以内");
          return;
        }

        if (url) {
          src = url.createObjectURL(file);
        } else {
          src = e.target.result;
        }
        self.idCardsrc.idCardfront = src;
        var reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = function(e) {
          //self.formset.IDCardfrontBase64 = e.target.result;
          img.src = this.result;
        };
        var img = new Image(),
          width = 800, //image resize   压缩后的宽
          quality = 0.3, //image quality  压缩质量
          canvas = document.createElement("canvas"),
          drawer = canvas.getContext("2d");
        img.onload = function() {
          canvas.width = width;
          canvas.height = width * (img.height / img.width);
          drawer.drawImage(img, 0, 0, canvas.width, canvas.height);
          var base64 = canvas.toDataURL("image/jpeg", quality); // 压缩后的base64图片
          self.formset.IDCardfrontBase64 = base64;
        };
      }
    },

    uploadInpuBackChange: function(e) {
      let src,
        url = window.URL || window.webkitURL || window.mozURL,
        files = e.target.files,
        self = this;
      for (var i = 0, len = files.length; i < len; ++i) {
        var file = files[i];
        if (file.size > 4 * 1024 * 1024) {
          Toast.fail("身份证图片大小4MB以内");
          return;
        }

        if (url) {
          src = url.createObjectURL(file);
        } else {
          src = e.target.result;
        }
        self.idCardsrc.idCardback = src;
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function(e) {
          //self.formset.IDCardbackBase64 = e.target.result;
          img.src = this.result;
        };
        var img = new Image(),
          width = 800, //image resize   压缩后的宽
          quality = 0.3, //image quality  压缩质量
          canvas = document.createElement("canvas"),
          drawer = canvas.getContext("2d");
        img.onload = function() {
          canvas.width = width;
          canvas.height = width * (img.height / img.width);
          drawer.drawImage(img, 0, 0, canvas.width, canvas.height);
          var base64 = canvas.toDataURL("image/jpeg", quality); // 压缩后的base64图片
          self.formset.IDCardbackBase64 = base64;
        };
      }
    },
    //获取图形验证码
    getpiccode: function() {
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/login/getverificationcodepic", {
          params: { codeGuid: this.VerificationCodePic.OnceString }
        })
        .then(
          function(d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
              this.VerificationCodePic = rep.Data;
            } else {
              Toast.fail(rep.Message);
            }
          },
          function(d) {
            console.log(d);
          }
        );
    },
    //获取验证码
    getcode: function() {
      if (this.formset.Telephone == "") {
        Toast.fail("手机号不能为空");
        return;
      }
      if (this.PicCodeValue == "") {
        Toast.fail("图形验证码不能为空");
        return;
      }
      const TIME_COUNT = 60;
      if (!this.codetimer) {
        this.waitminutes = TIME_COUNT;
        this.getcodeshow = false;
        this.codetimer = setInterval(() => {
          if (this.waitminutes > 0 && this.waitminutes <= TIME_COUNT) {
            this.waitminutes--;
          } else {
            this.getcodeshow = true;
            clearInterval(this.codetimer);
            this.codetimer = null;
          }
        }, 1000);
      }
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/login/getverificationcode", {
          params: {
            picCode: this.PicCodeValue,
            onceString: this.VerificationCodePic.OnceString,
            telephone: this.formset.Telephone,
            loginType: this.loginType
          }
        })
        .then(
          function(d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
            } else {
              this.waitminutes = 0;
              this.getpiccode();
              Toast.fail(rep.Message);
            }
          },
          function(d) {
            console.log(d);
          }
        );
    },
    //验证验证码
    checkcode: function() {
      if (this.formset.Telephone == "") {
        Toast.fail("手机号不能为空");
        return;
      }
      if (
        this.PicCodeValue == undefined ||
        this.PicCodeValue == null ||
        this.PicCodeValue == ""
      ) {
        Toast.fail("图形验证码不能为空");
        return;
      }

      if (this.code == undefined || this.code == null || this.code == "") {
        Toast.fail("点击获取验证码填写短信码");
        return;
      }
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/login/checkverificationcode", {
          params: {
            telephone: this.formset.Telephone,
            code: this.code,
            loginType: this.loginType
          }
        })
        .then(
          function(d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
              this.dosave();
            } else {
              this.getpiccode();
              Toast.fail(rep.Message);
            }
          },
          function(d) {
            console.log(d);
          }
        );
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/set/messageset.vue